/**
 * Get embedded key from script tag data attribute
 * This is used to identify the company context when subdomain is not available
 * (e.g., when embedded in Shopify stores)
 * The embedded key comes from the script tag: <script data-embedded-key="...">
 */
export function getEmbeddedKey(): string | null {
  console.log('[getEmbeddedKey] Starting search for embedded key');
  
  // Get from script tag data attributes
  const scripts = document.querySelectorAll('script[data-embedded-key]');
  console.log('[getEmbeddedKey] Found scripts with data-embedded-key:', scripts.length);
  
  // Also log all scripts to see what's available
  const allScripts = document.querySelectorAll('script');
  console.log('[getEmbeddedKey] Total scripts on page:', allScripts.length);
  allScripts.forEach((script, index) => {
    const src = script.getAttribute('src') || 'inline';
    const dataAttrs: string[] = [];
    Array.from(script.attributes).forEach(attr => {
      if (attr.name.startsWith('data-')) {
        dataAttrs.push(`${attr.name}="${attr.value}"`);
      }
    });
    console.log(`[getEmbeddedKey] Script ${index}: src="${src}", data attrs: [${dataAttrs.join(', ')}]`);
  });
  
  for (const script of Array.from(scripts)) {
    const embeddedKey = script.getAttribute('data-embedded-key');
    console.log('[getEmbeddedKey] Found script with data-embedded-key:', embeddedKey);
    if (embeddedKey) {
      console.log('[getEmbeddedKey] Returning embedded key:', embeddedKey);
      return embeddedKey;
    }
  }

  console.warn('[getEmbeddedKey] No embedded key found in script tags');
  return null;
}
